<template lang="pug">
.charity-bar
  //- img(src="~assets/charity-bar-alipay.png")
  .copy
    //- .line 所有收入将用于支付宝公益项目
    .line 本购票服务仅对年满十八周岁人士开放
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'CharityBarAlipay',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.charity-bar
  pointer-events: all
  position: relative
  width: 100%
  height: pxToRem(50)
  display: flex
  align-items: center
  justify-content: center
  img
    width: 100%
    object-fit: contain
  .copy
    position: absolute
    // left: 35%
    font-size: 12px
    color: black
</style>
